import { createContext, useContext } from "react";
import type { LoginData } from "../../utils/zod/auth";

export interface AuthContextProps {
  token: string | null;
  authenticated: boolean;
  mustChangePassword: boolean;
  mustAcceptTerms: boolean;
  login: (data: LoginData) => void;
  logout: () => void;
  markPasswordChanged: (mustAcceptTerms: boolean) => void;
  markLegalAccepted: () => void;
  syncOnboardingFromGate: (state: {
    mustChangePassword: boolean;
    mustAcceptTerms: boolean;
  }) => void;
}

export const AuthContext = createContext<AuthContextProps>({
  token: null,
  authenticated: false,
  mustChangePassword: false,
  mustAcceptTerms: false,
  login: () => {},
  logout: () => {},
  markPasswordChanged: () => {},
  markLegalAccepted: () => {},
  syncOnboardingFromGate: () => {},
});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
